(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certanu-deutschland-champions"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ct-scope').forEach(function(scope){
    if(scope.dataset.ctInit) return;
    scope.dataset.ctInit = '1';
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('ct-in'); io.unobserve(e.target); }
      });
    },{threshold:.14});
    scope.querySelectorAll('.ct-rise').forEach(function(el){ io.observe(el); });
    var qs = scope.querySelectorAll('.ct-q');
    qs.forEach(function(d){
      d.addEventListener('toggle', function(){
        if(d.open){ qs.forEach(function(o){ if(o!==d) o.open = false; }); }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certanu-legacy-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  var scope = document.currentScript ? document.currentScript.closest('.ct-scope') : null;
  var root = scope || document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = root.querySelectorAll('[data-ct-reveal]');
  if('IntersectionObserver' in window && !reduce){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('ct-in'); io.unobserve(e.target);} });
    },{threshold:0.14, rootMargin:'0px 0px -8% 0px'});
    revealEls.forEach(function(el){ io.observe(el); });
  } else { revealEls.forEach(function(el){ el.classList.add('ct-in'); }); }

  var pxEls = Array.prototype.slice.call(root.querySelectorAll('[data-parallax]'));
  var ticking=false;
  function upd(){var vh=window.innerHeight;pxEls.forEach(function(el){var r=el.getBoundingClientRect();var c=r.top+r.height/2;var o=(c-vh/2)*parseFloat(el.getAttribute('data-parallax'));el.style.transform='translate3d(0,'+o.toFixed(1)+'px,0)';});ticking=false;}
  if(!reduce && pxEls.length){window.addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(upd);ticking=true;}},{passive:true});upd();}

  root.querySelectorAll('.ct-acc__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.ct-acc__item');var panel=item.querySelector('.ct-acc__a');var open=item.classList.contains('ct-open');
      if(open){item.classList.remove('ct-open');btn.setAttribute('aria-expanded','false');panel.style.maxHeight=null;}
      else{item.classList.add('ct-open');btn.setAttribute('aria-expanded','true');panel.style.maxHeight=panel.scrollHeight+'px';}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certanu-spanien-champion"] && !Shopify.designMode) return;
  try {
    
(function(){
  var scope = document.currentScript ? document.currentScript.closest('.ct-scope') : null;
  var root = scope || document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = root.querySelectorAll('[data-ct-reveal]');
  if('IntersectionObserver' in window && !reduce){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('ct-in'); io.unobserve(e.target);} });
    },{threshold:0.14, rootMargin:'0px 0px -8% 0px'});
    revealEls.forEach(function(el){ io.observe(el); });
  } else { revealEls.forEach(function(el){ el.classList.add('ct-in'); }); }

  var pxEls = Array.prototype.slice.call(root.querySelectorAll('[data-parallax]'));
  var ticking=false;
  function upd(){var vh=window.innerHeight;pxEls.forEach(function(el){var r=el.getBoundingClientRect();var c=r.top+r.height/2;var o=(c-vh/2)*parseFloat(el.getAttribute('data-parallax'));el.style.transform='translate3d(0,'+o.toFixed(1)+'px,0)';});ticking=false;}
  if(!reduce && pxEls.length){window.addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(upd);ticking=true;}},{passive:true});upd();}

  root.querySelectorAll('.ct-acc__q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.ct-acc__item');var panel=item.querySelector('.ct-acc__a');var open=item.classList.contains('ct-open');
      if(open){item.classList.remove('ct-open');btn.setAttribute('aria-expanded','false');panel.style.maxHeight=null;}
      else{item.classList.add('ct-open');btn.setAttribute('aria-expanded','true');panel.style.maxHeight=panel.scrollHeight+'px';}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certanu-spanien-premium-trikot"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ct-scope').forEach(function(scope){
    if(scope.dataset.ctInit) return;
    scope.dataset.ctInit = '1';
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('ct-in'); io.unobserve(e.target); }
      });
    },{threshold:.14});
    scope.querySelectorAll('.ct-rise').forEach(function(el){ io.observe(el); });
    var qs = scope.querySelectorAll('.ct-q');
    qs.forEach(function(d){
      d.addEventListener('toggle', function(){
        if(d.open){ qs.forEach(function(o){ if(o!==d) o.open = false; }); }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
